export enum Stage {
  pending,
  fulfilled,
  rejected,
}
